import React from "react";
import {OfferType} from "../../../../../../core/models/enums/offerType";
import {Images} from "../../../../../../core/utilities/images";
import "./OfferLeading.scss";

interface IProps {
  offerType: OfferType;
}

const OfferLeading = (props: IProps) => {

  const getSrc = (): string => {
    switch (props.offerType) {
      case OfferType.P2S:
        return Images.offer_icon_ticket;
      case OfferType.J2F:
      case OfferType.J2F_S:
        return Images.offer_icon_final;
      case OfferType.P2C:
      case OfferType.CONTINUE:
        return Images.offer_icon_star;
      case OfferType.GIVE_UP:
        return Images.offer_icon_star_giveup;
      default:
        return "";
    }
  }

  return (
    <img id="offer-leading" src={getSrc()} alt="offer"/>
  );
}

export default OfferLeading;
